<template>
  <div class="row mt-4">
    <p>
      If your grant application asks for letters of support, make a list of
      people or organizations that will benefit from your proposed project. Set
      up meetings so you can explain in detail what the project will be, and ask
      if they would be willing to write a letter of support to help you get the
      funding you need. To simplify the process, choose a template from below to
      send the person or organization writing your letter to help them get
      started.
    </p>
    <div class="col text-left">
      <div class="text-center mb-4">
        <h5>Letter Templates</h5>
      </div>
      <ResponseCategories
        v-bind:ResponseCategories="responsesCategories"
        @addGrantApplicationResponse="addGrantApplicationResponse"
      />
    </div>
    <div v-if="grantApplication != null" class="col">
      <h5 class="mb-4">Grant Letters</h5>
      <div class="card">
        <div class="card-body text-left pt-0">
          <ResponsesToShow
            v-bind:Responses="responsesToShow"
            v-bind:ShowCategory="false"
            NoResponsesText="Use the templates to the left to create letters of support."
            @fillInBlank="fillInBlank"
            @removedApplicationResponse="applicationResponseRemoved"
          />
        </div>
      </div>
    </div>
    <GrantResponseAnswerModal
      v-bind:ResponseToEdit="responseBlankToEdit"
      @responseAnswerModalClosed="responseAnswerModalClosed"
      @createdNewBlankAnswer="newBlankAnswerCreated"
      @createdNewResponseAnswer="newResponseAnswerCreated"
      @updatedResponseAnswer="responseAnswerUpdated"
    />
  </div>
</template>

<script>
import GrantResponseAnswerModal from "@/modals/MyGrants/GrantResponseAnswerModal.vue";
import ResponseCategories from "@/components/MyGrants/ResponseCategories";
import ResponsesToShow from "@/components/MyGrants/ResponsesToShow";
import $ from "jquery";

export default {
  name: "ApplicationQuestionResponse",
  components: {
    GrantResponseAnswerModal,
    ResponseCategories,
    ResponsesToShow
  },
  props: {
    GrantApplication: Object
  },
  data() {
    return {
      responsesCategories: [],
      grantApplication: this.GrantApplication,
      responseBlankToEdit: null,
      responsesToShow: []
    };
  },
  watch: {
    GrantApplication: function() {
      this.grantApplication = this.GrantApplication;
      this.filterResponses();
    }
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    this.responsesCategories = await this.$getApplicationTemplateResponseCategories(
      8,
      true
    );
    this.filterResponses();
    this.$store.commit("updateLoading", false);
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
  },
  methods: {
    filterResponses() {
      this.responsesToShow = this.$filterResponsesToShow(
        this.responsesCategories,
        this.grantApplication.Grant_Application_Responses
      );
    },
    fillInBlank(responseBlankToEdit) {
      this.responseBlankToEdit = responseBlankToEdit;
      $("#questionResponseAnswerModal").modal("show");
    },
    async addGrantApplicationResponse(response) {
      var view = this;
      view.$store.commit("updateLoading", true);
      await view
        .$createGrantApplicationResponse(
          view.grantApplication.Grant_Application_Id,
          response.Application_Template_Response_Id
        )
        .then(appResponse => {
          view.responsesToShow.push(appResponse);
          this.$emit("responseCreated", appResponse);
        });
      view.$store.commit("updateLoading", false);
    },
    applicationResponseRemoved(response) {
      this.responsesToShow = this.responsesToShow.filter(
        r =>
          r.Grant_Application_Response_Id !=
          response.Grant_Application_Response_Id
      );
      this.$emit("responseRemoved", response);
    },
    responseAnswerModalClosed() {
      this.responseBlankToEdit = null;
    },
    newBlankAnswerCreated(newBlankAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      this.responsesToShow[
        responseIndex
      ].Application_Template_Response.Template_Response_Blank_Answers.push(
        newBlankAnswer
      );
      this.$emit(
        "blankAnswerCreated",
        newBlankAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    },
    newResponseAnswerCreated(newResponseAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      this.responsesToShow[
        responseIndex
      ].Grant_Application_Response_Answers.push(newResponseAnswer);
      this.$emit(
        "responseAnswerCreated",
        newResponseAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    },
    responseAnswerUpdated(updatedResponseAnswer) {
      var responseIndex = this.responsesToShow.findIndex(
        r =>
          r.Grant_Application_Response_Id ==
          this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
      var responseToUpdate = this.responsesToShow[responseIndex];
      var responseAnswerIndex = responseToUpdate.Grant_Application_Response_Answers.findIndex(
        a =>
          a.Grant_Application_Response_Answer_Id ==
          updatedResponseAnswer.Grant_Application_Response_Answer_Id
      );
      responseToUpdate.Grant_Application_Response_Answers[
        responseAnswerIndex
      ] = updatedResponseAnswer;
      this.$set(this.responsesToShow, responseIndex, responseToUpdate);
      this.$emit(
        "responseAnswerUpdated",
        updatedResponseAnswer,
        this.responseBlankToEdit.response.Grant_Application_Response_Id
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
